import { useAtom, useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { deleteModalState, editDrawerState } from '~/state/settings_practitioners/atoms';

import { EditDrawer } from './EditDrawer';
import { useDrawerAnimation } from './use-drawer-animation';

export const EditPractitionerDrawer = () => {
  const { currentProps, handleTransitionEnd } = useDrawerAnimation();
  const setDeleteModalState = useSetAtom(deleteModalState);
  const [state, setState] = useAtom(editDrawerState);

  const handleClose = useCallback(
    () => setState((_state) => ({ ..._state, isOpen: false, practitionerId: null })),
    [setState],
  );

  const handleOpenDeleteModal = useCallback(() => {
    if (state.practitionerId) {
      setDeleteModalState({
        isOpen: true,
        practitionerId: state.practitionerId,
        error: null,
      });
    }
  }, [setDeleteModalState, state.practitionerId]);

  return (
    <EditDrawer
      open={currentProps.isOpen}
      privilege={currentProps.isPrivilege}
      practitionerId={currentProps.practitionerId}
      onClose={handleClose}
      onOpenModal={handleOpenDeleteModal}
      onTransitionEnd={handleTransitionEnd}
    />
  );
};
